/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Blmodifiedfrance_Name2Inputs */

const en_resources_blmodifiedfrance_name2 = /** @type {(inputs: Resources_Blmodifiedfrance_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery notes to re-issue FRANCE`)
};

const fr_resources_blmodifiedfrance_name2 = /** @type {(inputs: Resources_Blmodifiedfrance_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BLs à rééditer FRANCE`)
};

const es_resources_blmodifiedfrance_name2 = /** @type {(inputs: Resources_Blmodifiedfrance_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Albaranes a reeditar FRANCE`)
};

const de_resources_blmodifiedfrance_name2 = /** @type {(inputs: Resources_Blmodifiedfrance_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu auszustellende Lieferscheine FRANCE`)
};

const nl_resources_blmodifiedfrance_name2 = /** @type {(inputs: Resources_Blmodifiedfrance_Name2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opnieuw uit te geven leveringsbonnen FRANCE`)
};

/**
* | output |
* | --- |
* | "Delivery notes to re-issue FRANCE" |
*
* @param {Resources_Blmodifiedfrance_Name2Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_blmodifiedfrance_name2 = /** @type {((inputs?: Resources_Blmodifiedfrance_Name2Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Blmodifiedfrance_Name2Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_blmodifiedfrance_name2(inputs)
	if (locale === "fr") return fr_resources_blmodifiedfrance_name2(inputs)
	if (locale === "es") return es_resources_blmodifiedfrance_name2(inputs)
	if (locale === "de") return de_resources_blmodifiedfrance_name2(inputs)
	return nl_resources_blmodifiedfrance_name2(inputs)
});
export { resources_blmodifiedfrance_name2 as "resources.blModifiedFrance.name" }